import React from 'react';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import api from '@/api/services/index';
import FooterPageHead from '@/components/Common/FooterPageHead';
import styles from '@/styles/pages/PrivacyPolicy/PrivacyPolicy.module.scss';
import { getEndUserAgreement, getEndUserData } from '@/lib/apis';

export const getStaticProps: GetStaticProps = async () => {
  const endUserAgreement = await getEndUserAgreement();
  const endUserData = await getEndUserData();
  if (!endUserAgreement || !endUserData) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      endUser: endUserAgreement.map((item: any) => ({
        ...item,
        EndUser: item.EndUser.map((endUserId: any) => {
          const foundedEndUserData = endUserData.find((endUserDataId: any) => endUserDataId.id === endUserId);
          if (!foundedEndUserData) {
            return null;
          }
          return foundedEndUserData;
        }).filter((endUserData: any) => endUserData !== null),
      })),
    }, // will be passed to the page component as props
    revalidate: true,
  };
};
const EndUser = ({ endUser }: InferGetStaticPropsType<typeof getStaticProps>) => (
  <>
    <FooterPageHead headTitle={'End User Agreement'} />
    <div className={styles.wrapper}>
      {endUser?.map((items) => (
        <>
          <span className='whitespace-pre-wrap'>{items.topSummary}</span>
          {items.EndUser?.map((data, index) => (
            <div key={index} className={styles.textBox}>
              <h2>{data.title}</h2>
              <span className='whitespace-pre-wrap'>{data.summary}</span>
            </div>
          ))}
        </>
      ))}
    </div>
  </>
);

export default EndUser;
